export default __webpack_public_path__ + "static/media/checkReport.76fed3d6.png";